import { SuperAdminConstants } from '../../../_constants';

const initialState = { getSwotTextLoading: true, data: '', error: false };

export function getSwotTextReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_GET_SWOT_TEXT:
            return {
                getSwotTextLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_GET_SWOT_TEXT:
            return {
                getSwotTextLoading: false,
                data: action.getSwotText,
                error: false
            };
        case SuperAdminConstants.GET_SWOT_TEXT_ERROR:
            return {
                getSwotTextLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/SwotText/getSwotText.reducer.js